import PropTypes from 'prop-types';
import { useRef } from 'react';
import * as yup from 'yup';
import CrudCard from '../../common/CrudCard/CrudCard';
import {
  useDonationAmounts,
  useCreateDonationAmount,
  useUpdateDonationAmount,
  useDeleteDonationAmount
} from 'hooks/useDonationSettings';

/* -------------------------------------------------------------------------- */
function DonationAmounts({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();

  const { donationAmounts, isLoading: loading } = useDonationAmounts();
  const { createDonationAmount, isCreating: createLoading } = useCreateDonationAmount();
  const { updateDonationAmount, isUpdating: updateLoading } = useUpdateDonationAmount();
  const { deleteDonationAmount, isDeleting: deleteLoading } = useDeleteDonationAmount();

  const handleCreate = async ({ amount, description }) => {
    try {
      await createDonationAmount({
        amount,
        description
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async ({ id, data }) => {
    try {
      await updateDonationAmount({
        id,
        data: {
          amount: data.amount,
          description: data.description
        }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDonationAmount(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const list = donationAmounts.map(amount => ({
    id: amount.id,
    isOrgLevel: !amount.branch_id,
    values: [
      {
        value: amount.amount,
        name: 'amount'
      },
      {
        value: amount.description,
        name: 'description'
      }
    ]
  }));

  if (list) {
    list.unshift({
      id: null,
      values: [
        {
          value: 'Other',
          name: 'amount'
        },
        { value: 'Custom donation amount', name: 'description' }
      ]
    });
  }

  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      loading={loading}
      editData={handleEdit}
      deleteData={handleDelete}
      createLoading={createLoading}
      updateLoading={updateLoading}
      deleteLoading={deleteLoading}
      listTitle={'Current Donation Amounts'}
      title={'Donation Amounts'}
      inputs={[
        {
          name: 'amount',
          placeholder: 'Add Donation Amount',
          type: 'text',
          required: true,
          value: '',
          label: 'Donation Amount',
          validation: yup
            .number()
            .typeError('Amount must be a number')
            .required('Donation Amount is required')
        },
        {
          name: 'description',
          placeholder: 'Add Description',
          type: 'text',
          required: false,
          value: '',
          label: 'Amount Description',
          validation: yup.string()
        }
      ]}
      list={list}
      subject={subject}
    />
  );
}

DonationAmounts.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default DonationAmounts;
